/* HÖÖKEN theme scripts — no dependencies.
   Everything degrades gracefully: the page is fully usable with JS off. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };
  var lerp = function (a, b, t) { return a + (b - a) * t; };

  /* ---------------------------------------------------------------- Header */
  var header = document.querySelector('[data-site-header]');
  if (header) {
    var onScrollHeader = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 24);
    };
    onScrollHeader();
    window.addEventListener('scroll', onScrollHeader, { passive: true });
  }

  /* ----------------------------------------------------------- Mobile menu */
  var menu = document.querySelector('[data-mobile-menu]');
  var openBtn = document.querySelector('[data-menu-open]');
  var closeBtn = document.querySelector('[data-menu-close]');
  if (menu && openBtn && closeBtn) {
    var setMenu = function (open) {
      menu.setAttribute('aria-hidden', open ? 'false' : 'true');
      openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) closeBtn.focus(); else openBtn.focus();
    };
    openBtn.addEventListener('click', function () { setMenu(true); });
    closeBtn.addEventListener('click', function () { setMenu(false); });
    menu.addEventListener('click', function (e) { if (e.target.closest('a')) setMenu(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.getAttribute('aria-hidden') === 'false') setMenu(false);
    });
  }

  /* ------------------------------------------------------------ Hawk flight
     Scroll-driven: a fixed-position hawk glides along an arc from the lower
     left of the hero and lands on the faint mark next to the product heading.
     Pure transforms, no scroll hijacking, decorative only. */
  var hawk = document.querySelector('[data-hawk]');
  var hero = document.querySelector('[data-hero]');
  var target = document.querySelector('[data-flight-target]');
  var landing = target && target.querySelector('[data-flight-landing]');
  if (hawk && hero && target && landing) {
    var enabled = hawk.dataset.enabled !== 'false';
    if (!enabled || reduceMotion.matches) {
      hawk.classList.add('is-static');
    } else {
      var ticking = false;
      var vw = window.innerWidth, vh = window.innerHeight;
      var small = vw < 600;
      landing.style.opacity = '0';

      var update = function () {
        ticking = false;
        var heroRect = hero.getBoundingClientRect();
        var targetRect = target.getBoundingClientRect();
        var landRect = landing.getBoundingClientRect();
        var heroH = heroRect.height;
        var start = heroH * 0.04;
        var end = (targetRect.top - heroRect.top) - vh * 0.42;
        var p = clamp((-heroRect.top - start) / Math.max(1, end - start), 0, 1);

        if (p >= 1) {
          hawk.classList.add('is-done');
          landing.style.opacity = '';
          return;
        }
        hawk.classList.remove('is-done');

        var hawkW = hawk.offsetWidth;
        var x0 = -hawkW, y0 = vh * (small ? 0.62 : 0.66);
        var x1 = landRect.left, y1 = landRect.top;
        var arc = Math.sin(p * Math.PI) * vh * (small ? 0.08 : 0.16);
        var x = lerp(x0, x1, p);
        var y = lerp(y0, y1, p) - arc;
        var sEnd = landRect.width / hawkW;
        var s = small ? lerp(0.7, sEnd, p) : lerp(0.75, sEnd, p) + Math.sin(p * Math.PI) * 0.45;
        var r = lerp(-9, 0, p) - Math.sin(p * Math.PI) * 6;
        var o = p <= 0 ? 0 : (p < 0.1 ? p / 0.1 : (p > 0.85 ? 1 - ((p - 0.85) / 0.15) : 1));

        hawk.style.transformOrigin = '0 0';
        hawk.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0) rotate(' + r.toFixed(2) + 'deg) scale(' + s.toFixed(3) + ')';
        hawk.style.opacity = o.toFixed(3);
        landing.style.opacity = (p > 0.85 ? ((p - 0.85) / 0.15) * 0.26 : 0).toFixed(3);
      };
      var request = function () {
        if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
      };
      window.addEventListener('scroll', request, { passive: true });
      window.addEventListener('resize', function () {
        vw = window.innerWidth; vh = window.innerHeight; small = vw < 600; request();
      });
      window.addEventListener('load', request);
      request();

      if (reduceMotion.addEventListener) {
        reduceMotion.addEventListener('change', function (e) {
          if (e.matches) { hawk.classList.add('is-static'); landing.style.opacity = ''; }
        });
      }
    }
  }

  /* --------------------------------------------------------- Product cards */
  document.querySelectorAll('[data-product-card]').forEach(function (card) {
    var media = card.querySelector('.product-card__media');
    var buttons = card.querySelectorAll('.product-card__views button');
    buttons.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var alt = b.dataset.view === 'alt';
        media.classList.toggle('show-alt', alt);
        buttons.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      });
    });
  });

  /* ------------------------------------------------------------- Newsletter */
  var nlSuccess = document.querySelector('[data-newsletter-success]');
  if (nlSuccess) {
    var nlSection = nlSuccess.closest('[data-newsletter]') || nlSuccess;
    window.addEventListener('load', function () {
      nlSection.scrollIntoView({ block: 'center', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      nlSuccess.focus({ preventScroll: true });
    });
  }
  var nlForm = document.querySelector('[data-newsletter] form');
  if (nlForm) {
    nlForm.addEventListener('submit', function () {
      var b = nlForm.querySelector('[type="submit"]');
      if (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); }
    });
  }

  /* ----------------------------------------------------------------- Reveal */
  var reveals = document.querySelectorAll('.reveal');
  if (reveals.length && 'IntersectionObserver' in window && !reduceMotion.matches) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ------------------------------------------------------------------ Toast */
  var toastEl;
  var toast = function (msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2800);
  };
  window.HookenToast = toast;

  /* ------------------------------------------------------------ Cart count */
  var updateCartCount = function (count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', String(count));
    });
  };

  /* ---------------------------------------------------------- Product page */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var section = form.closest('[data-product-section]') || document;
    var jsonEl = section.querySelector('[data-product-json]');
    var product = null;
    try { product = jsonEl ? JSON.parse(jsonEl.textContent) : null; } catch (e) { product = null; }

    var idInput = form.querySelector('input[name="id"]');
    var priceEl = section.querySelector('[data-price]');
    var compareEl = section.querySelector('[data-compare-price]');
    var submit = form.querySelector('[data-add-to-cart]');
    var status = form.querySelector('[data-form-status]');
    var moneyFormat = form.dataset.moneyFormat || '{{amount}} kr';

    var formatMoney = function (cents) {
      var amount = (cents / 100);
      var str;
      if (/no_decimals/.test(moneyFormat)) str = Math.round(amount).toLocaleString('sv-SE');
      else str = amount.toLocaleString('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, str);
    };

    var currentVariant = function () {
      if (!product) return null;
      var selected = [];
      form.querySelectorAll('[data-option-index]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        selected[Number(group.dataset.optionIndex)] = checked ? checked.value : null;
      });
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return selected[i] == null || o === selected[i]; });
      }) || null;
    };

    var render = function () {
      if (!product) return; // preview / no product data: leave the button as rendered
      var v = currentVariant();
      if (!v) {
        if (submit) { submit.disabled = true; submit.textContent = submit.dataset.unavailable || 'Ej tillgänglig'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) { compareEl.textContent = formatMoney(v.compare_at_price); compareEl.hidden = false; }
        else compareEl.hidden = true;
      }
      if (submit) {
        submit.disabled = !v.available;
        submit.textContent = v.available ? (submit.dataset.add || 'Lägg i varukorg') : (submit.dataset.soldOut || 'Slutsåld');
      }
    };
    form.querySelectorAll('[data-option-index] input').forEach(function (i) { i.addEventListener('change', render); });
    render();

    // Quantity stepper
    var qty = form.querySelector('input[name="quantity"]');
    form.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = parseInt(qty.value || '1', 10) + (b.dataset.qty === '+' ? 1 : -1);
        qty.value = Math.max(1, n);
      });
    });

    // Gallery thumbs
    var mainImg = section.querySelector('[data-gallery-main]') || section.querySelector('.pdp__slide img');
    section.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.src = t.dataset.src;
        if (t.dataset.alt) mainImg.alt = t.dataset.alt;
        section.querySelectorAll('[data-gallery-thumb]').forEach(function (x) { x.setAttribute('aria-pressed', x === t ? 'true' : 'false'); });
      });
    });

    // AJAX add to cart (falls back to regular submit if fetch fails)
    form.addEventListener('submit', function (e) {
      var addUrl = form.dataset.addUrl;
      if (!addUrl || !window.fetch) return; // normal submit
      if (form.dataset.demo === 'true') {
        e.preventDefault();
        toast(form.dataset.demoMessage || 'Demo: kopplas till Shopify vid publicering');
        return;
      }
      e.preventDefault();
      if (submit) submit.disabled = true;
      var fd = new FormData(form);
      fetch(addUrl, { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body && (res.body.description || res.body.message) || 'Kunde inte lägga i varukorgen');
          return fetch(form.dataset.cartUrl || '/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          toast(form.dataset.addedMessage || 'Tillagd i varukorgen');
          if (status) status.textContent = '';
        })
        .catch(function (err) {
          if (status) status.textContent = form.dataset.errorMessage || err.message;
        })
        .finally(function () { if (submit) submit.disabled = false; });
    });
  });
})();
